import styled from '@emotion/styled'
import { PNToastAlertType } from '../PNToastNotification.routing'
import { breakpoint, calcRem } from '../../../__styling'
import { tokens } from '@news-mono/design-tokens'

// PerthNow Colors
const pnColors = tokens.perthnow.colors
const pnPalette = pnColors.palette

export interface AlertComponentContainerProps {
    type: PNToastAlertType
    useMaxWidth: boolean
    forceMaxWidth?: boolean
    marginTop?: string | number
}
export const StyledToastComponentContainer = styled(
    'div',
)<AlertComponentContainerProps>(
    ({ type, useMaxWidth, forceMaxWidth = false, marginTop }) => ({
        marginTop: marginTop,
        display: 'flex',
        padding: calcRem(12, 16),
        flexDirection: 'row',
        justifyContent: 'start',
        alignItems: 'flex-start',
        borderRadius: calcRem(8),
        background:
            type === 'success'
                ? pnPalette.greenJadeShade[50]
                : type === 'error' || type === 'warning'
                ? pnPalette.redCrisis[50]
                : type === 'verify'
                ? pnPalette.redCrisis[50]
                : pnPalette.blackShade[50],

        p: {
            marginTop: 0,
            marginBottom: 0,
        },

        // Apply styling to anything smaller than a desktop
        width: '100%',

        // Apply styling for anything bigger than a mobile
        [breakpoint('sm')]: {
            background:
                type === 'success'
                    ? pnPalette.greenJadeShade[50]
                    : type === 'error' || type === 'warning'
                    ? pnPalette.redCrisis[50]
                    : type === 'verify'
                    ? pnPalette.pinkThuliteShade[50]
                    : pnPalette.blackShade[50],
        },

        // Apply styling to anything bigger than a tablet
        [breakpoint('mlg')]: {
            width: forceMaxWidth ? '100%' : 'fit-content',
            maxWidth: useMaxWidth ? calcRem(400) : undefined,
        },
    }),
)
